$(document).on('click', '.toggle-password__item', {}, function (e) {
  let togglePassword = $(e.currentTarget)
  const passwordInput = togglePassword.parent().find('input')

  const oldType = passwordInput.attr('type')
  const newType = oldType === 'password' ? 'text' : 'password'
  passwordInput.attr('type', newType).focus()

  togglePassword.find('.show-' + oldType).show()
  togglePassword.find('.show-' + newType).hide()
})
